import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MdPayment } from 'react-icons/md';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import ButtonLink from 'components/ButtonLink';
import PaymentConfirmVector from 'assets/vectors/PaymentConfirm.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { initializeCart } from 'store/cart';
import { updateClassroom } from 'store/classroom';
import { setError } from 'store/error';
import './index.css';

function PaymentConfirm() {
    const [isProcessing, setIsProcessing] = useState(true);
    const [courses, setCourses] = useState([]);
    const [tests, setTests] = useState([]);
    const [paymentAmount, setPaymentAmount] = useState(0);

    const dispatch = useAppDispatch();
    const { user } = useAppSelector(state => state.user);
    const { paymentId } = useParams();

    const refreshCartAndClassroom = () => {
        axios.get('payments/cart/')
            .then(res => {
                // console.log(res.data);
                dispatch(initializeCart({
                    bundles: res.data?.cartBundles,
                    courses: res.data?.cartCourses,
                    tests: res.data?.cartTests                
                }));
            });
        axios.get('students/classroom/')
            .then(res => {
                // console.log(res.data);
                dispatch(updateClassroom({
                    courses: res.data?.courses,
                    tests: res.data?.tests
                }));
            });
    }

    const getPaymentConfirmation = (orderNumber: string) => {
        axios.get(`payments/confirm/${orderNumber}/`)
            .then(res => {
                // console.log(res);
                const {
                    courses,
                    tests,
                    paymentAmount
                } = res.data;

                setCourses(courses);
                setTests(tests);
                setPaymentAmount(paymentAmount);
                setIsProcessing(false);
                refreshCartAndClassroom();
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    useEffect(() => {
        if (paymentId) getPaymentConfirmation(paymentId);
    }, [paymentId]);

    if (isProcessing) return <></>;

    return (
        <div className='layout'>
            <Helmet
                title='Payment Success - The SAT Crash Course'
            />
            <div className='paymentConfirm'>
                <img 
                    className='paymentConfirm__vector'
                    src={PaymentConfirmVector}
                    alt='Payment Confirmation'
                />
                <h1 className='paymentConfirm__header'>
                    Paid Successfully
                </h1>
                <p className='paymentConfirm__text'>
                    Thank you, your payment has been confirmed.<br/>
                    You have successfully registered for our program.
                </p>
                <div className='paymentConfirm__info'>
                    <h4 className='paymentConfirm__infoHeader'>
                        <MdPayment className='paymentConfirm__infoHeaderIcon' />
                        Transaction details
                    </h4>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <p>Order #</p>
                                </td>
                                <td>
                                    <b>{paymentId}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Email</p>
                                </td>
                                <td>
                                    <b>{user.email}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Name</p>
                                </td>
                                <td>
                                    <b>{user.firstName} {user.lastName}</b>
                                </td>
                            </tr>
                            {courses.length > 0 &&
                                <tr>
                                    <td>
                                        <p>Courses</p>
                                    </td>
                                    <td>
                                        {courses.map(course => (
                                            <b key={course.name}>{course.name}<br/></b>
                                        ))}
                                    </td>
                                </tr>
                            }
                            {tests.length > 0 &&
                                <tr>
                                    <td>
                                        <p>Tests</p>
                                    </td>
                                    <td>
                                        {tests.map(test => (
                                            <b key={test.testId}>{test.name}<br/></b>
                                        ))}
                                    </td>
                                </tr>
                            }
                            <tr>
                                <td>
                                    <p>Charged</p>
                                </td>
                                <td className='paymentConfirm__total'>
                                    <b>${paymentAmount}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='paymentConfirm__buttonGroup'>
                    {courses.length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/courses' secondary>
                            MY COURSES
                        </ButtonLink>
                    }
                    {tests.filter(test => test.type === 'Digital SAT').length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/tests/digital-sat'>
                            MY SAT
                        </ButtonLink>
                    }
                    {tests.filter(test => test.type === 'Digital PSAT').length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/tests/digital-psat'>
                            MY PSAT
                        </ButtonLink>
                    }
                    {tests.filter(test => test.type === 'Digital ACT').length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/tests/digital-act'>
                            MY ACT
                        </ButtonLink>
                    }
                    {/* <ButtonLink className='paymentConfirm__button' to='/tests'>
                        MY TESTS
                    </ButtonLink> */}
                </div>
            </div>
        </div>
    );
}

export default PaymentConfirm;